import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { useTranslations } from 'next-intl'
import React from 'react'
import ImportantInformationBox, { Note } from './importantMessages'
import { noteConfigs } from './noteConfigs'

export type NoteConfig = {
    title: string
    getContent: (itineraryData: any) => string | undefined
}

const ImportantMessagesWrapper: React.FC = () => {
    const itineraryId = useGetItineraryId()
    const t = useTranslations('common')
    const { itineraryData } = useGetItineraryDataQuery(
        { itineraryId },
        { selectFromResult: ({ data }) => ({ itineraryData: data?.itineraryData }) }
    )

    const notes: Note[] = []

    if (itineraryData) {
        noteConfigs.forEach(({ title, getContent }) => {
            const content = getContent(itineraryData, t)
            if (content) {
                notes.push({
                    title: t(title),
                    content
                })
            }
        })

        // Handle itineraryMessages array separately
        const itineraryMessages = itineraryData.meta?.message?.itineraryMessages
        if (Array.isArray(itineraryMessages)) {
            itineraryMessages.forEach((message: string) => {
                if (message) {
                    notes.push({
                        title: t('Important!'),
                        content: message
                    })
                }
            })
        } else if (itineraryMessages) {
            notes.push({
                title: t('Important!'),
                content: itineraryMessages
            })
        }
    }

    if (notes.length === 0) return null

    return <ImportantInformationBox notes={notes} t={t} />
}

export default ImportantMessagesWrapper
